import Vue from 'vue'
import Vuex from 'vuex'
// tag 标签页
// import tagsView from './modules/tagsView'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    // tagsView
  },
  state: {
    isMobile: false
  },
  getters: {},
  mutations: {
    GET_DEVICE_TYPE: (state, type) => {
      state.isMobile = type
    //   this.$store.commit("GET_DEVICE_TYPE", 'courseQACenter');
    }
  },
  actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js